interface AnswerRow {
  answer: string;
  correct: string;
  type: string;
}

export const ExamResultsToHTML = (data: any) => {
  if (data.summary_tables) {
    data.summary_tables = [
      data.summary_tables[0],
      data.summary_tables[2],
      data.summary_tables[4],
      data.summary_tables[6],
      data.summary_tables[1],
      data.summary_tables[3],
    ];
  }
  return (
    <div className="resultsPage">
      <div className="pageContent results">
        <table className="resultsSummaryTable">
          <tr>
            <td>
              <div className="headline">
                <div className="logo">
                  <img
                    alt="company logo"
                    src="https://www.firstchoiceprep.com/wp-content/themes/fcp/components/header/src//images/fcp_logo.png"
                  />
                </div>
                <h1>Your Results</h1>
                <h2 className="userInfo">
                  <span>Name:</span> {data.userName} <br />{" "}
                  <span>Test Date:</span> {data.testDate}
                </h2>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <table className="resultsSummaryContent">
                <tr>
                  <td>
                    <h2>
                      {data?.decision?.toString() === "both"
                        ? `You performed equally well on the SAT and ACT portions of this diagnostic.`
                        : `You're Better-Suited to ${data?.decision}!`}
                    </h2>
                  </td>
                </tr>
                <tr>
                  <td>
                    <table className="resultsHolder">
                      <tr>
                        <td className="resultsBox">
                          <div
                            className={[
                              "headline",
                              data?.decision === "the ACT" ? "active" : "",
                            ].join(" ")}
                          >
                            {data?.decision === "the ACT" && (
                              <img
                                src="https://testing.firstchoiceprep.com/wp-content/uploads/2023/11/checkmark.png"
                                alt="checkmark"
                              />
                            )}
                            ACT Composite:{" "}
                            <span>{data?.act_summary?.act_score}</span>
                            <p
                              className="equivalentHeader"
                              style={{
                                fontSize: "18px",
                                padding: "0px",
                                margin: "0px",
                              }}
                            >
                              SAT Equivalent:{" "}
                              <span style={{ fontSize: "18px" }}>
                                {data.satEquivalent}
                              </span>
                            </p>
                            {/* <span>({data?.act_summary?.sat_score} SAT)</span> */}
                          </div>
                          <div className="subheadline">
                            {data?.legacyACTScoring
                              ? `Your ACT Composite score is the average of your scores on each of the three sections of the ACT: English, Math, Reading and Science.`
                              : `Your ACT composite score is the average of your scores on the English, Math, and Reading sections. Your Science score is reported separately and is not included in your composite score.`}
                          </div>
                          <div className="resultsTable">
                            <div className="resultsRow">
                              <p>English:</p>
                              <p style={{ color: "#000" }}>
                                {data?.act_summary?.details.english}
                              </p>
                            </div>
                            <div className="resultsRow">
                              <p>Math:</p>
                              <p style={{ color: "#000" }}>
                                {data?.act_summary?.details.math}
                              </p>
                            </div>
                            <div className="resultsRow">
                              <p>Reading:</p>
                              <p style={{ color: "#000" }}>
                                {data?.act_summary?.details.reading}
                              </p>
                            </div>
                            {data?.legacyACTScoring && (
                              <div className="resultsRow">
                                <p>Science:</p>
                                <p style={{ color: "#000" }}>
                                  {data?.act_summary?.details.science}
                                </p>
                              </div>
                            )}
                          </div>
                          {!data?.legacyACTScoring && (
                            <div className="resultsTable bottomTable">
                              <div className="resultsRow">
                                <p>Science:</p>
                                <p style={{ color: "#000" }}>
                                  {data?.act_summary?.details.science}
                                </p>
                              </div>
                              <div className="resultsRow textOnly">
                                <p
                                  style={{
                                    color: "#000",
                                    fontWeight: 500,
                                  }}
                                >
                                  The Science score is not included in the
                                  Composite score.
                                </p>
                              </div>
                            </div>
                          )}
                        </td>
                        <td className="resultsBox">
                          <div
                            className={[
                              "headline",
                              data?.decision === "the SAT" ? "active" : "",
                            ].join(" ")}
                          >
                            {data?.decision === "the SAT" && (
                              <img
                                src="https://testing.firstchoiceprep.com/wp-content/uploads/2023/11/checkmark.png"
                                alt="checkmark"
                              />
                            )}
                            SAT Total Score:{" "}
                            <span>{data?.sat_summary?.sat_score}</span>
                            <p
                              className="equivalentHeader"
                              style={{
                                fontSize: "18px",
                                padding: "0px",
                                margin: "0px",
                              }}
                            >
                              ACT Equivalent:{" "}
                              <span style={{ fontSize: "18px" }}>
                                {data.actEquivalent}
                              </span>
                            </p>
                            {/* <span>({data?.sat_summary?.act_score} ACT)</span> */}
                          </div>
                          <div className="subheadline">
                            Your SAT Total Score is the sum of your scores on
                            the Reading and Writing and the Math portions of the
                            SAT.
                          </div>
                          <div className="resultsTable active">
                            <div className="resultsRow">
                              <p>Reading and Writing:</p>
                              <p style={{ color: "#000" }}>
                                {data?.sat_summary?.details.verbal}
                              </p>
                            </div>
                            <div className="resultsRow">
                              <p>Math:</p>
                              <p style={{ color: "#000" }}>
                                {data?.sat_summary?.details.math}
                              </p>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </table>

                    <table className="performanceTable">
                      <tr>
                        <td className="leftColumn" valign="top">
                          <h3>Areas of Strength</h3>
                          <table>
                            <tr>
                              <td className="performance-td">
                                <table>
                                  <tbody>
                                    <tr className="datapoint-row">
                                      <td>
                                        {data.topCategories &&
                                          data.topCategories[0] && (
                                            <img
                                              src={`https://testing.firstchoiceprep.com/wp-content/plugins/firstchoiceprep-api/images/numbers/${data.topCategories[0].value}.png`}
                                              alt="donut"
                                              width="80"
                                              height="80"
                                            />
                                          )}
                                      </td>
                                      <td>
                                        {data.topCategories &&
                                          data.topCategories[0] && (
                                            <p>{data.topCategories[0].title}</p>
                                          )}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                              <td className="performance-td">
                                <table>
                                  <tbody>
                                    <tr className="datapoint-row">
                                      <td>
                                        {data.topCategories &&
                                          data.topCategories[1] && (
                                            <img
                                              src={`https://testing.firstchoiceprep.com/wp-content/plugins/firstchoiceprep-api/images/numbers/${data.topCategories[1].value}.png`}
                                              alt="donut"
                                              width="80"
                                              height="80"
                                            />
                                          )}
                                      </td>
                                      <td>
                                        {data.topCategories &&
                                          data.topCategories[1] && (
                                            <p>{data.topCategories[1].title}</p>
                                          )}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            <tr>
                              <td className="performance-td">
                                <table>
                                  <tbody>
                                    <tr className="datapoint-row">
                                      <td>
                                        {data.topCategories &&
                                          data.topCategories[2] && (
                                            <img
                                              src={`https://testing.firstchoiceprep.com/wp-content/plugins/firstchoiceprep-api/images/numbers/${data.topCategories[2].value}.png`}
                                              alt="donut"
                                              width="80"
                                              height="80"
                                            />
                                          )}
                                      </td>
                                      <td>
                                        {data.topCategories &&
                                          data.topCategories[2] && (
                                            <p>{data.topCategories[2].title}</p>
                                          )}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                              <td className="performance-td">
                                <table>
                                  <tbody>
                                    <tr className="datapoint-row">
                                      <td>
                                        {data.topCategories &&
                                          data.topCategories[3] && (
                                            <img
                                              src={`https://testing.firstchoiceprep.com/wp-content/plugins/firstchoiceprep-api/images/numbers/${data.topCategories[3].value}.png`}
                                              alt="donut"
                                              width="80"
                                              height="80"
                                            />
                                          )}
                                      </td>
                                      <td>
                                        {data.topCategories &&
                                          data.topCategories[3] && (
                                            <p>{data.topCategories[3].title}</p>
                                          )}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </table>
                        </td>
                        <td className="rightColumn" valign="top">
                          <h3>Opportunities for Growth</h3>
                          <table>
                            <tr>
                              <td className="performance-td">
                                <table>
                                  <tbody>
                                    <tr className="datapoint-row">
                                      <td>
                                        {data.worstCategories &&
                                          data.worstCategories[0] && (
                                            <img
                                              src={`https://testing.firstchoiceprep.com/wp-content/plugins/firstchoiceprep-api/images/numbers_alt/${data.worstCategories[0].value}.png`}
                                              alt="donut"
                                              width="80"
                                              height="80"
                                            />
                                          )}
                                      </td>
                                      <td>
                                        {data.worstCategories &&
                                          data.worstCategories[0] && (
                                            <p>
                                              {data.worstCategories[0].title}
                                            </p>
                                          )}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                              <td className="performance-td">
                                <table>
                                  <tbody>
                                    <tr className="datapoint-row">
                                      <td>
                                        {data.worstCategories &&
                                          data.worstCategories[1] && (
                                            <img
                                              src={`https://testing.firstchoiceprep.com/wp-content/plugins/firstchoiceprep-api/images/numbers_alt/${data.worstCategories[1].value}.png`}
                                              alt="donut"
                                              width="80"
                                              height="80"
                                            />
                                          )}
                                      </td>
                                      <td>
                                        {data.worstCategories &&
                                          data.worstCategories[1] && (
                                            <p>
                                              {data.worstCategories[1].title}
                                            </p>
                                          )}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            <tr>
                              <td className="performance-td">
                                <table>
                                  <tbody>
                                    <tr className="datapoint-row">
                                      <td>
                                        {data.topCategories &&
                                          data.topCategories[2] && (
                                            <img
                                              src={`https://testing.firstchoiceprep.com/wp-content/plugins/firstchoiceprep-api/images/numbers_alt/${data.worstCategories[2].value}.png`}
                                              alt="donut"
                                              width="80"
                                              height="80"
                                            />
                                          )}
                                      </td>
                                      <td>
                                        {data.worstCategories &&
                                          data.worstCategories[2] && (
                                            <p>
                                              {data.worstCategories[2].title}
                                            </p>
                                          )}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                              <td className="performance-td">
                                <table>
                                  <tbody>
                                    <tr className="datapoint-row">
                                      <td>
                                        {data.worstCategories &&
                                          data.worstCategories[3] && (
                                            <img
                                              src={`https://testing.firstchoiceprep.com/wp-content/plugins/firstchoiceprep-api/images/numbers_alt/${data.worstCategories[3].value}.png`}
                                              alt="donut"
                                              width="80"
                                              height="80"
                                            />
                                          )}
                                      </td>
                                      <td>
                                        {data.worstCategories &&
                                          data.worstCategories[3] && (
                                            <p>
                                              {data.worstCategories[3].title}
                                            </p>
                                          )}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td>
              <hr />
            </td>
          </tr>
        </table>
        <table className="answersMatrix">
          <tr>
            <td colSpan={2}>
              <div className="headline">
                ACT <span>Answers</span>
              </div>
              <div className="subheadline">
                Below is a detailed accounting of your performance on each of
                the four sections of the ACT portion of our diagnostic test. In
                each section, you’ll see the number of each question, the
                correct answer, your answer, and the Question Category it
                belongs to.
              </div>
            </td>
          </tr>
          <tr>
            <td width={"50%"} valign="top">
              <table className="matrixTable">
                <tr>
                  <td>
                    <table className="matrixColumn" style={{ width: "100%" }}>
                      <tr>
                        <td colSpan={2}>
                          <div className="matrixHeadline">
                            <p>
                              English:{" "}
                              <span>{data?.act_summary?.details.english}</span>
                            </p>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table style={{ width: "100%" }}>
                            <tr
                              className="matrixData act-english"
                              style={{ backgroundColor: "#bad7a7" }}
                            >
                              <td className="matrixDataCol">
                                {" "}
                                <p>Question #</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Your Answer</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Correct Answer</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Question Category</p>
                              </td>
                            </tr>
                            {data?.act_answers?.english.map(
                              (item: AnswerRow, index: number) => {
                                return (
                                  <tr className="matrixData act-english">
                                    <td className="matrixDataCol">
                                      <p>{index + 1}</p>
                                    </td>
                                    {item.answer ? (
                                      <td className="matrixDataCol">
                                        <p>{item.answer}</p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol unanswered">
                                        <p>omitted</p>
                                      </td>
                                    )}
                                    {item.correct !== item.answer ? (
                                      <td className="matrixDataCol incorrect">
                                        <p>{item.correct}</p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol">
                                        <img
                                          src="https://testing.firstchoiceprep.com/wp-content/uploads/2023/11/checkmark.png"
                                          alt="check"
                                        />
                                      </td>
                                    )}

                                    <td className="matrixDataCol">
                                      <p>{item.type}</p>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td></td>
                </tr>
              </table>
            </td>
            <td width={"50%"} valign="top">
              <table className="matrixTable">
                <tr>
                  <td>
                    <table className="matrixColumn" style={{ width: "100%" }}>
                      <tr>
                        <td colSpan={2}>
                          <div className="matrixHeadline">
                            <p>
                              Math:{" "}
                              <span>{data?.act_summary?.details.math}</span>
                            </p>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table style={{ width: "100%" }}>
                            <tr
                              className="matrixData act-math"
                              style={{ backgroundColor: "#bad7a7" }}
                            >
                              <td className="matrixDataCol">
                                {" "}
                                <p>Question #</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Your Answer</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Correct Answer</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Question Category</p>
                              </td>
                            </tr>
                            {data?.act_answers?.math.map(
                              (item: AnswerRow, index: number) => {
                                return (
                                  <tr className="matrixData act-math">
                                    <td className="matrixDataCol">
                                      <p>{index + 1}</p>
                                    </td>
                                    {item.answer ? (
                                      <td className="matrixDataCol">
                                        <p>{item.answer}</p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol unanswered">
                                        <p>omitted</p>
                                      </td>
                                    )}
                                    {item.correct !== item.answer ? (
                                      <td className="matrixDataCol incorrect">
                                        <p>{item.correct}</p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol">
                                        <img
                                          src="https://testing.firstchoiceprep.com/wp-content/uploads/2023/11/checkmark.png"
                                          alt="check"
                                        />
                                      </td>
                                    )}

                                    <td className="matrixDataCol">
                                      <p>{item.type}</p>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td></td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td width={"50%"} valign="top">
              <table className="matrixTable">
                <tr>
                  <td>
                    <table
                      className="matrixColumn"
                      style={{
                        width: "100%",
                        background: "none",
                        boxShadow: "none",
                      }}
                    >
                      <tr style={{ height: "20px" }}>
                        <td></td>
                      </tr>
                    </table>
                    <table className="matrixColumn" style={{ width: "100%" }}>
                      <tr>
                        <td colSpan={2}>
                          <div className="matrixHeadline">
                            <p>
                              Reading:{" "}
                              <span>{data?.act_summary?.details.reading}</span>
                            </p>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table style={{ width: "100%" }}>
                            <tr
                              className="matrixData act-reading"
                              style={{ backgroundColor: "#bad7a7" }}
                            >
                              <td className="matrixDataCol">
                                {" "}
                                <p>Question #</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Your Answer</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Correct Answer</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Question Category</p>
                              </td>
                            </tr>
                            {data?.act_answers?.reading.map(
                              (item: AnswerRow, index: number) => {
                                return (
                                  <tr className="matrixData act-reading">
                                    <td className="matrixDataCol">
                                      <p>{index + 1}</p>
                                    </td>
                                    {item.answer ? (
                                      <td className="matrixDataCol">
                                        <p>{item.answer}</p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol unanswered">
                                        <p>omitted</p>
                                      </td>
                                    )}
                                    {item.correct !== item.answer ? (
                                      <td className="matrixDataCol incorrect">
                                        <p>{item.correct}</p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol">
                                        <img
                                          src="https://testing.firstchoiceprep.com/wp-content/uploads/2023/11/checkmark.png"
                                          alt="check"
                                        />
                                      </td>
                                    )}

                                    <td className="matrixDataCol">
                                      <p>{item.type}</p>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td></td>
                </tr>
              </table>
            </td>
            <td width={"50%"} valign="top">
              <table className="matrixTable">
                <tr>
                  <td>
                    <table
                      className="matrixColumn"
                      style={{
                        width: "100%",
                        background: "none",
                        boxShadow: "none",
                      }}
                    >
                      <tr style={{ height: "20px" }}>
                        <td></td>
                      </tr>
                    </table>
                    <table className="matrixColumn" style={{ width: "100%" }}>
                      <tr>
                        <td colSpan={2}>
                          <div className="matrixHeadline">
                            <p>
                              Science:{" "}
                              <span>{data?.act_summary?.details.science}</span>
                            </p>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table style={{ width: "100%" }}>
                            <tr
                              className="matrixData act-science"
                              style={{ backgroundColor: "#bad7a7" }}
                            >
                              <td className="matrixDataCol">
                                {" "}
                                <p>Question #</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Your Answer</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Correct Answer</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Question Category</p>
                              </td>
                            </tr>
                            {data?.act_answers?.science.map(
                              (item: AnswerRow, index: number) => {
                                return (
                                  <tr className="matrixData act-science">
                                    <td className="matrixDataCol">
                                      <p>{index + 1}</p>
                                    </td>
                                    {item.answer ? (
                                      <td className="matrixDataCol">
                                        <p>{item.answer}</p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol unanswered">
                                        <p>omitted</p>
                                      </td>
                                    )}
                                    {item.correct !== item.answer ? (
                                      <td className="matrixDataCol incorrect">
                                        <p>{item.correct}</p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol">
                                        <img
                                          src="https://testing.firstchoiceprep.com/wp-content/uploads/2023/11/checkmark.png"
                                          alt="check"
                                        />
                                      </td>
                                    )}

                                    <td className="matrixDataCol">
                                      <p>{item.type}</p>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td></td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <hr />
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <div className="headline">
                SAT <span>Answers</span>
              </div>
              <div className="subheadline">
                Below is a detailed accounting of your performance on each of
                the sections of the SAT portion of our diagnostic test. In each
                section, you’ll see the number of each question, the correct
                answer, your answer, and the Question Category it belongs to.
              </div>
            </td>
          </tr>
          <tr>
            <td width={"50%"} valign="top">
              <table className="matrixTable">
                <tr>
                  <td>
                    <table
                      className="matrixColumn sat"
                      style={{ width: "100%" }}
                    >
                      <tr>
                        <td colSpan={2}>
                          <div
                            className="matrixHeadline"
                            style={{ paddingBottom: "5px", paddingTop: "5px" }}
                          >
                            <p style={{ padding: "0" }}>
                              Reading and Writing:{" "}
                              <span>{data?.sat_summary?.details.verbal}</span>
                            </p>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div
                            className="matrixHeadline subheadline"
                            style={{
                              marginTop: "5px",
                              paddingTop: "0px",
                              paddingBottom: "5px",
                            }}
                          >
                            Module 1
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table style={{ width: "100%" }}>
                            <tr
                              className="matrixData sat-reading-writing"
                              style={{ backgroundColor: "#bad7a7" }}
                            >
                              <td className="matrixDataCol">
                                {" "}
                                <p
                                  style={{
                                    paddingTop: "0",
                                    paddingBottom: "0",
                                  }}
                                >
                                  Question #
                                </p>
                              </td>
                              <td className="matrixDataCol">
                                <p
                                  style={{
                                    paddingTop: "0",
                                    paddingBottom: "0",
                                  }}
                                >
                                  Your Answer
                                </p>
                              </td>
                              <td className="matrixDataCol">
                                <p
                                  style={{
                                    paddingTop: "0",
                                    paddingBottom: "0",
                                  }}
                                >
                                  Correct Answer
                                </p>
                              </td>
                              <td className="matrixDataCol">
                                <p
                                  style={{
                                    paddingTop: "0",
                                    paddingBottom: "0",
                                  }}
                                >
                                  Question Category
                                </p>
                              </td>
                            </tr>
                            {data?.sat_answers?.verbal.map(
                              (item: AnswerRow, index: number) => {
                                return (
                                  <tr className="matrixData sat-reading-writing">
                                    <td className="matrixDataCol">
                                      <p
                                        style={{
                                          paddingTop: "0",
                                          paddingBottom: "0",
                                        }}
                                      >
                                        {index + 1}
                                      </p>
                                    </td>
                                    {item.answer ? (
                                      <td className="matrixDataCol">
                                        <p
                                          style={{
                                            paddingTop: "0",
                                            paddingBottom: "0",
                                          }}
                                        >
                                          {item.answer}
                                        </p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol unanswered">
                                        <p
                                          style={{
                                            paddingTop: "0",
                                            paddingBottom: "0",
                                          }}
                                        >
                                          omitted
                                        </p>
                                      </td>
                                    )}
                                    {item.correct !== item.answer ? (
                                      <td className="matrixDataCol incorrect">
                                        <p
                                          style={{
                                            paddingTop: "0",
                                            paddingBottom: "0",
                                          }}
                                        >
                                          {item.correct}
                                        </p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol">
                                        <img
                                          src="https://testing.firstchoiceprep.com/wp-content/uploads/2023/11/checkmark.png"
                                          alt="check"
                                          style={{
                                            margin: "0px",
                                            width: "15px",
                                          }}
                                        />
                                      </td>
                                    )}

                                    <td className="matrixDataCol">
                                      <p
                                        style={{
                                          paddingTop: "0",
                                          paddingBottom: "0",
                                        }}
                                      >
                                        {item.type}
                                      </p>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div
                            className="matrixHeadline subheadline"
                            style={{
                              marginTop: "5px",
                              paddingTop: "0px",
                              paddingBottom: "5px",
                            }}
                          >
                            Module 2
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table>
                            <tr
                              className="matrixData sat-reading-writing"
                              style={{ backgroundColor: "#bad7a7" }}
                            >
                              <td className="matrixDataCol">
                                {" "}
                                <p
                                  style={{
                                    paddingTop: "0",
                                    paddingBottom: "0",
                                  }}
                                >
                                  Question #
                                </p>
                              </td>
                              <td className="matrixDataCol">
                                <p
                                  style={{
                                    paddingTop: "0",
                                    paddingBottom: "0",
                                  }}
                                >
                                  Your Answer
                                </p>
                              </td>
                              <td className="matrixDataCol">
                                <p
                                  style={{
                                    paddingTop: "0",
                                    paddingBottom: "0",
                                  }}
                                >
                                  Correct Answer
                                </p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Question Category</p>
                              </td>
                            </tr>
                            {data?.sat_answers?.verbal2.map(
                              (item: AnswerRow, index: number) => {
                                return (
                                  <tr className="matrixData sat-reading-writing">
                                    <td className="matrixDataCol">
                                      <p
                                        style={{
                                          paddingTop: "0",
                                          paddingBottom: "0",
                                        }}
                                      >
                                        {index + 1}
                                      </p>
                                    </td>
                                    {item.answer ? (
                                      <td className="matrixDataCol">
                                        <p
                                          style={{
                                            paddingTop: "0",
                                            paddingBottom: "0",
                                          }}
                                        >
                                          {item.answer}
                                        </p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol unanswered">
                                        <p
                                          style={{
                                            paddingTop: "0",
                                            paddingBottom: "0",
                                          }}
                                        >
                                          omitted
                                        </p>
                                      </td>
                                    )}
                                    {item.correct !== item.answer ? (
                                      <td className="matrixDataCol incorrect">
                                        <p>{item.correct}</p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol">
                                        <img
                                          src="https://testing.firstchoiceprep.com/wp-content/uploads/2023/11/checkmark.png"
                                          alt="check"
                                          style={{
                                            margin: "0px",
                                            width: "15px",
                                          }}
                                        />
                                      </td>
                                    )}

                                    <td className="matrixDataCol">
                                      <p
                                        style={{
                                          paddingTop: "0",
                                          paddingBottom: "0",
                                        }}
                                      >
                                        {item.type}
                                      </p>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td></td>
                </tr>
              </table>
            </td>
            <td width={"50%"} valign="top">
              <table className="matrixTable">
                <tr>
                  <td>
                    <table
                      className="matrixColumn sat"
                      style={{ width: "100%" }}
                    >
                      <tr>
                        <td colSpan={2}>
                          <div
                            className="matrixHeadline"
                            style={{ paddingBottom: "5px", paddingTop: "5px" }}
                          >
                            <p style={{ padding: "0" }}>
                              {" "}
                              Math:{" "}
                              <span>{data?.sat_summary?.details.math}</span>
                            </p>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div
                            className="matrixHeadline subheadline"
                            style={{
                              marginTop: "5px",
                              paddingTop: "0px",
                              paddingBottom: "5px",
                            }}
                          >
                            Module 1
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table style={{ width: "100%" }}>
                            <tr
                              className="matrixData sat-math"
                              style={{ backgroundColor: "#bad7a7" }}
                            >
                              <td className="matrixDataCol">
                                {" "}
                                <p
                                  style={{
                                    paddingTop: "0",
                                    paddingBottom: "0",
                                  }}
                                >
                                  Question #
                                </p>
                              </td>
                              <td className="matrixDataCol">
                                <p
                                  style={{
                                    paddingTop: "0",
                                    paddingBottom: "0",
                                  }}
                                >
                                  Your Answer
                                </p>
                              </td>
                              <td className="matrixDataCol">
                                <p
                                  style={{
                                    paddingTop: "0",
                                    paddingBottom: "0",
                                  }}
                                >
                                  Correct Answer
                                </p>
                              </td>
                              <td className="matrixDataCol">
                                <p
                                  style={{
                                    paddingTop: "0",
                                    paddingBottom: "0",
                                  }}
                                >
                                  Question Category
                                </p>
                              </td>
                            </tr>
                            {data?.sat_answers?.math.map(
                              (item: AnswerRow, index: number) => {
                                return (
                                  <tr className="matrixData sat-math">
                                    <td className="matrixDataCol">
                                      <p
                                        style={{
                                          paddingTop: "0",
                                          paddingBottom: "0",
                                        }}
                                      >
                                        {index + 1}
                                      </p>
                                    </td>
                                    {item.answer ? (
                                      <td className="matrixDataCol">
                                        <p
                                          style={{
                                            paddingTop: "0",
                                            paddingBottom: "0",
                                          }}
                                        >
                                          {item.answer}
                                        </p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol unanswered">
                                        <p
                                          style={{
                                            paddingTop: "0",
                                            paddingBottom: "0",
                                          }}
                                        >
                                          omitted
                                        </p>
                                      </td>
                                    )}
                                    {item.correct !== item.answer ? (
                                      <td className="matrixDataCol incorrect">
                                        <p
                                          style={{
                                            paddingTop: "0",
                                            paddingBottom: "0",
                                          }}
                                        >
                                          {item.correct}
                                        </p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol">
                                        <img
                                          src="https://testing.firstchoiceprep.com/wp-content/uploads/2023/11/checkmark.png"
                                          alt="check"
                                          style={{
                                            margin: "0px",
                                            width: "15px",
                                          }}
                                        />
                                      </td>
                                    )}

                                    <td className="matrixDataCol">
                                      <p
                                        style={{
                                          paddingTop: "0",
                                          paddingBottom: "0",
                                        }}
                                      >
                                        {item.type}
                                      </p>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div
                            className="matrixHeadline subheadline"
                            style={{
                              marginTop: "5px",
                              paddingTop: "0px",
                              paddingBottom: "5px",
                            }}
                          >
                            Module 2
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table>
                            <tr
                              className="matrixData sat-math"
                              style={{ backgroundColor: "#bad7a7" }}
                            >
                              <td className="matrixDataCol">
                                {" "}
                                <p
                                  style={{
                                    paddingTop: "0",
                                    paddingBottom: "0",
                                  }}
                                >
                                  Question #
                                </p>
                              </td>
                              <td className="matrixDataCol">
                                <p
                                  style={{
                                    paddingTop: "0",
                                    paddingBottom: "0",
                                  }}
                                >
                                  Your Answer
                                </p>
                              </td>
                              <td className="matrixDataCol">
                                <p
                                  style={{
                                    paddingTop: "0",
                                    paddingBottom: "0",
                                  }}
                                >
                                  Correct Answer
                                </p>
                              </td>
                              <td className="matrixDataCol">
                                <p
                                  style={{
                                    paddingTop: "0",
                                    paddingBottom: "0",
                                  }}
                                >
                                  Question Category
                                </p>
                              </td>
                            </tr>
                            {data?.sat_answers?.math2.map(
                              (item: AnswerRow, index: number) => {
                                return (
                                  <tr className="matrixData sat-math">
                                    <td className="matrixDataCol">
                                      <p
                                        style={{
                                          paddingTop: "0",
                                          paddingBottom: "0",
                                        }}
                                      >
                                        {index + 1}
                                      </p>
                                    </td>
                                    {item.answer ? (
                                      <td className="matrixDataCol">
                                        <p
                                          style={{
                                            paddingTop: "0",
                                            paddingBottom: "0",
                                          }}
                                        >
                                          {item.answer}
                                        </p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol unanswered">
                                        <p
                                          style={{
                                            paddingTop: "0",
                                            paddingBottom: "0",
                                          }}
                                        >
                                          omitted
                                        </p>
                                      </td>
                                    )}
                                    {item.correct !== item.answer ? (
                                      <td className="matrixDataCol incorrect">
                                        <p
                                          style={{
                                            paddingTop: "0",
                                            paddingBottom: "0",
                                          }}
                                        >
                                          {item.correct}
                                        </p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol">
                                        <img
                                          src="https://testing.firstchoiceprep.com/wp-content/uploads/2023/11/checkmark.png"
                                          alt="check"
                                          style={{
                                            margin: "0px",
                                            width: "15px",
                                          }}
                                        />
                                      </td>
                                    )}

                                    <td className="matrixDataCol">
                                      <p
                                        style={{
                                          paddingTop: "0",
                                          paddingBottom: "0",
                                        }}
                                      >
                                        {item.type}
                                      </p>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td></td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
        <table className="summary-table">
          <tr
            className="summary-table-headline"
            style={{ backgroundColor: "#000" }}
          >
            <td>
              <h4>Performance Summary</h4>
              <p style={{ marginBottom: "0px", fontSize: "13px" }}>
                Below is a detailed accounting of how well you performed on each
                of the Question Categories on our diagnostic test. This will
                help you determine the specific skills and question types you’ll
                need to improve upon to get to mastery.
              </p>
            </td>
          </tr>
          <tr className="summary-table-holder">
            <td
              style={{
                backgroundColor: "#7AAE4E",
                padding: "20px",
                width: "100%",
              }}
            >
              {(data?.summary_tables)
                .filter(
                  (item: { table_name: string }) =>
                    item && item?.table_name.substring(0, 3) === "ACT"
                )
                .map((item: any, index: number) => {
                  if (!item) return <span></span>;
                  return (
                    <table
                      className="summaryTable"
                      key={Math.random()}
                      style={{ width: "100%" }}
                    >
                      <tr
                        className="headline"
                        style={{ backgroundColor: "#7AAE4E" }}
                      >
                        <td>{item.table_name}</td>
                      </tr>

                      {Object.keys(item?.categories).map((row: any) => {
                        return (
                          <tr
                            className="tableHolder"
                            style={{ backgroundColor: "#7AAE4E", width: "20%" }}
                          >
                            <td style={{ verticalAlign: "top" }}>
                              <table>
                                <tr>
                                  <td
                                    className="tableRow"
                                    style={{
                                      display: "inline-block",
                                      padding: "0",
                                    }}
                                  >
                                    <img
                                      src={`https://testing.firstchoiceprep.com/wp-content/plugins/firstchoiceprep-api/images/numbers/${Math.round(
                                        item.categories[row].value
                                      )}.png`}
                                      alt="donut"
                                      width={80}
                                      height={80}
                                    />
                                  </td>
                                  <td
                                    className="tableRow"
                                    style={{
                                      display: "inline-block",
                                      padding: "0",
                                    }}
                                  >
                                    <p
                                      className="catName"
                                      style={{
                                        margin: "0px",
                                        fontSize: "13px",
                                        paddingBottom: "3px",
                                      }}
                                    >
                                      {item.categories[row].title}:{" "}
                                    </p>
                                  </td>
                                  <td
                                    className="tableRow"
                                    style={{
                                      display: "inline-block",
                                      padding: "0",
                                    }}
                                  >
                                    <p>
                                      <span>
                                        {item.categories[row].correct}
                                      </span>{" "}
                                      correct out of{" "}
                                      {item.categories[row].correct +
                                        item.categories[row].incorrect}
                                    </p>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        );
                      })}
                    </table>
                  );
                })}
            </td>

            <td>
              <table className="summary-table">
                <tr
                  className="summary-table-headline"
                  style={{ backgroundColor: "#000", pageBreakBefore: "always" }}
                >
                  <td>
                    <h4>Performance Summary</h4>
                    <p style={{ marginBottom: "0px", fontSize: "13px" }}>
                      Below is a detailed accounting of how well you performed
                      on each of the Question Categories on our diagnostic test.
                      This will help you determine the specific skills and
                      question types you’ll need to improve upon to get to
                      mastery.
                    </p>
                  </td>
                </tr>
              </table>
            </td>

            <td
              style={{
                backgroundColor: "#7AAE4E",
                padding: "20px",
                background: "#567778",
                width: "100%",
                height: "980px",
              }}
            >
              {(data?.summary_tables)
                .filter(
                  (item: { table_name: string }) =>
                    item && item?.table_name.substring(0, 3) === "SAT"
                )
                .map((item: any, index: number) => {
                  if (!item) return <span></span>;
                  return (
                    <table
                      className="summaryTable"
                      key={Math.random()}
                      style={{ width: "100%" }}
                    >
                      <tr
                        className="headline"
                        style={{ backgroundColor: "#567778" }}
                      >
                        <td>{item.table_name}</td>
                      </tr>

                      {Object.keys(item?.categories).map(
                        (row: any, index: number) => {
                          return (
                            <tr
                              className="tableHolder"
                              style={{
                                backgroundColor: "#567778",
                                width: index < 6 ? "33%" : "auto",
                                justifyContent:
                                  index >= 6
                                    ? index % 2 === 0
                                      ? "flex-start"
                                      : "flex-end"
                                    : "center",
                                padding:
                                  index >= 6
                                    ? index % 2 === 0
                                      ? "22px 0 0 10px"
                                      : "22px 10px 0 0"
                                    : "0",
                              }}
                            >
                              <td>
                                <table style={{ width: "160px" }}>
                                  <tr>
                                    <td
                                      className="tableRow"
                                      style={{
                                        display: "inline-block",
                                        padding: "0",
                                      }}
                                    >
                                      <img
                                        src={`https://testing.firstchoiceprep.com/wp-content/plugins/firstchoiceprep-api/images/numbers_alt/${Math.round(
                                          item.categories[row].value
                                        )}.png`}
                                        alt="donut"
                                        width={80}
                                        height={80}
                                      />
                                    </td>
                                    <td
                                      className="tableRow"
                                      style={{
                                        display: "inline-block",
                                        padding: "0",
                                      }}
                                    >
                                      <p
                                        className="catName"
                                        style={{
                                          margin: "0px",
                                          fontSize: "13px",
                                          paddingBottom: "3px",
                                        }}
                                      >
                                        {item.categories[row].title}:{" "}
                                      </p>
                                    </td>
                                    <td
                                      className="tableRow"
                                      style={{
                                        display: "inline-block",
                                        padding: "0",
                                      }}
                                    >
                                      <p>
                                        <span>
                                          {item.categories[row].correct}
                                        </span>{" "}
                                        correct out of{" "}
                                        {item.categories[row].correct +
                                          item.categories[row].incorrect}
                                      </p>
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                          );
                        }
                      )}
                    </table>
                  );
                })}
            </td>
          </tr>
        </table>
        {/* <div className="pageContent results">
        
          
      </div> */}
      </div>
    </div>
  );
};
